import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { LocalStorageDataModel } from '@AppCore/constants/local-storage-data-model';
import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root',
})
export class GlobalUtilityService {
  public spinner$ = new Subject<boolean>();
  public errorCode$ = new Subject<number>();
  public loader$ = new BehaviorSubject<boolean>(false);
  public feedbackForm$ = new BehaviorSubject<boolean>(false);
  public toastMessage$ = new BehaviorSubject<{ type: string; message: string }>(
    { type: '', message: '' }
  );
  public userData$ = new BehaviorSubject<any>(null);

  constructor(private _router: Router) {}

  private loginStatus = new BehaviorSubject<boolean>(
    this.getDataFromLocalStorage(LocalStorageDataModel.AUTH_KEY) ? true : false
  );


  clearLocalStorage(){
    localStorage.clear();
  }

  getLoginStatus(): Observable<boolean> {
    return this.loginStatus.asObservable();
  }

  setLoginStatus(status: boolean): void {
    this.loginStatus.next(status);
  }

  setFeedbackFormStatus(status: boolean): void {
    this.feedbackForm$.next(status);
  }

  getFeedbackFormStatus(): Observable<boolean> {
    return this.feedbackForm$.asObservable();
  }

  setUserData(data: any) {
    this.setDataOnLocalStorage(
      LocalStorageDataModel.USER_DATA,
      JSON.stringify(data),
      true
    );
    this.userData$.next(data);
  }

  getUserData(): Observable<any> {
    let userData = this.getDataFromLocalStorage(
      LocalStorageDataModel.USER_DATA,
      true
    );
    if (userData) {
      this.userData$.next(JSON.parse(userData));
    }
    return this.userData$.asObservable();
  }

  showLoader() {
    this.loader$.next(true);
  }

  hideLoader() {
    this.loader$.next(false);
  }

  encryptData(data: any, SECRET_KEY: string) {
    const dataString = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(
      dataString,
      SECRET_KEY
    ).toString();
    return encryptedData;
  }

  decryptData(data: any, SECRET_KEY: string) {
    if (data && SECRET_KEY) {
      const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedData;
    } else {
      return null;
    }
  }

  showToast(type: string, message: string) {
    this.toastMessage$.next({ type, message });
    setTimeout(() => this.toastMessage$.next({ type: '', message: '' }), 3000); // auto hide after 3 seconds
  }

  // public getUserIPAddress(): Observable<{ ip: string }> {
  // 	return this._httpClient.get<{ ip: string }>("https://api.ipify.org/?format=json")
  // }

  public hideSpinner() {
    this.spinner$.next(false);
  }

  //======== STORAGE ========/
  setDataOnLocalStorage(
    key: string,
    value: string,
    encrypt = false,
    secret_key?: boolean
  ) {
    let secret;
    if (secret_key) {
      secret = localStorage.getItem(LocalStorageDataModel.AUTH_KEY);
    }
    if (encrypt) {
      value = this.encryptData(
        value,
        secret || 'LocalStorageDataModelAUTH_KEY'
      );
    }
    localStorage.setItem(key, value);
  }

  getDataFromLocalStorage(
    key: string,
    decrypt = false,
    secret_key: boolean = false
  ) {
    let secret;

    if (secret_key) {
      secret = localStorage.getItem(LocalStorageDataModel.AUTH_KEY);
    }

    var value = localStorage.getItem(key);
    if (value === null) {
      return '';
    }
    if (decrypt) {
      return this.decryptData(value, secret || 'LocalStorageDataModelAUTH_KEY');
    }
    return value;
  }

  getUserInfo() {
    return JSON.parse(
      this.getDataFromLocalStorage(LocalStorageDataModel.USER_DATA)
    );
  }

  removeDataFromLocalStorage(key: string) {
    localStorage.removeItem(key);
    return;
  }

  isUserLoggedIn(): boolean {
    if (this.getDataFromLocalStorage('token').length > 0) {
      return true;
    }
    return false;
  }

  logOut(redirectTo: string = '') {
    this.removeDataFromLocalStorage(LocalStorageDataModel.AUTH_KEY);
    this.removeDataFromLocalStorage(LocalStorageDataModel.USER_DATA);
    this.removeDataFromLocalStorage(LocalStorageDataModel.CART_ITEMS);
    const redirectUrl = redirectTo ? redirectTo : '';
    window.location.href = redirectUrl;
  }

  // // logOutWithoutRedirect() {
  // // 	this.removeDataFromLocalStorage(LocalStorageDataModel.AUTH_KEY);
  // // }

  // //======== ACCESSIBILITY ========/
  // get nativeWindow(): any {
  // 	return _window();
  // }

  isMobile(): boolean {
  	if (window.screen.width <= 992) {
  		return true;
  	}
  	return false;
  }

  // isWebAppOpenInMobile(): boolean {
  // 	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  // 		// true for mobile device
  // 		return true;
  // 	} else {
  // 		// false for not mobile device
  // 		return false;
  // 	}
  // }

  // isWebAppOpenInAppleDevices(): boolean {
  // 	if (/iPhone|iPad|iPod|Mac/i.test(navigator.userAgent)) {
  // 		// true for apple mobile device
  // 		return true;
  // 	} else {
  // 		// false for not apple mobile device
  // 		return false;
  // 	}
  // }

  public navigateToPath(URL: string, queryParams?: any): void {
    this._router.navigate([URL], { queryParams: queryParams });
  }

  // downloadFile(data: any, type: string = 'text/csv') {
  // 	const blob = new Blob([data], { type: type });
  // 	const url = window.URL.createObjectURL(blob);
  // 	this.nativeWindow.open(url);
  // }

  // errorHandler(response: HttpErrorResponse) {
  // 	this.hideSpinner();
  // 	if (response && response.error && response.error.errors && response.error.errors.length) {
  // 		return throwError(() => new Error(response.error.errors.reduce((previousValue: string, currentValue: { message: string }) => previousValue + currentValue.message + ' ', '')));
  // 	} else {
  // 		return throwError(() => new Error(`Some thing went wrong.`));
  // 	}
  // }
}
